// Star dimensions
export const STAR_WIDTH = 80;
export const STAR_HEIGHT = 80;

// Positioning constraints
export const CENTER_PADDING = 200;
export const MIN_DISTANCE = 100;
export const EDGE_MARGIN = 50; 